const pluginsDir = [
  {
    name: "Transform JSON",
    description: "Transform JSON strings using JavaScript.",
    url: "https://unpkg.com/@agney/jc-transform-json",
    tagName: "jc-transform-json",
  },
  {
    name: "Generate Type",
    description: "Generate types directly from JSON",
    url: "https://unpkg.com/quicktype-jsoncrew-plugin",
    tagName: "quicktype-jsoncrew-plugin",
  },
  {
    name: "Tree Viewer",
    description: "JSON Tree viewer UI",
    url: "https://unpkg.com/@agney/jc-viewer",
    tagName: "jc-viewer",
  },
];

export default pluginsDir;
